export const PRIORIDAD = [
    {id: 'alta', nombre: 'ALTA', color: '#ff4961'},
    {id: 'media', nombre: 'MEDIA', color: '#f77a1c'},
    {id: 'baja', nombre: 'BAJA', color: '#28d094'},
    {id: 'np', nombre: 'NO PRIORIZADO', color: '#6B6D78'},
    ]